import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  gap: 0.8rem;
`;

export { Container };
